import type { FC } from 'react';
import React, { memo } from 'react';
import { styled } from '@compiled/react';

import AkCrossIcon from '@atlaskit/icon/glyph/cross';
import Tooltip from '@atlaskit/tooltip/Tooltip';
import { N500, N0, N40 } from '@atlaskit/theme/colors';
import { token } from '@atlaskit/tokens';
import Button from '@atlaskit/button/custom-theme-button';

export type CloseButtonComponentProps = {
	onClose: () => void;
	closeLabel: string;
	closeAutoFocus?: boolean;
};

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const ExitButton = styled(Button)({
	// eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
	'&&': {
		background: token('elevation.surface', N0),
		marginTop: token('space.negative.025', '-2px'),
		'&:hover': {
			background: token('color.background.accent.gray.subtlest.hovered', N40),
		},
	},
});

export const CloseButton: FC<CloseButtonComponentProps> = memo(
	({ onClose, closeLabel, closeAutoFocus }) => (
		<Tooltip hideTooltipOnClick content={closeLabel}>
			<ExitButton
				onClick={onClose}
				testId="context-panel-close-button"
				iconBefore={<AkCrossIcon label={closeLabel} primaryColor={token('color.icon', N500)} />}
				autoFocus={closeAutoFocus}
			/>
		</Tooltip>
	),
);
